module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/employee/LayoutHeader.ejs -->\n<div class="col-xs-12">\n    <div class="inline-block-element m-r">\n        <div class="user-image"\n             style="background-image: url('+
((__t=( imageUrl ))==null?'':_.escape(__t))+
');">\n            <abbr>\n                '+
((__t=( nameAbbreviation ))==null?'':_.escape(__t))+
'\n            </abbr>\n        </div>\n        <a class="js-change-image-link">Change photo</a>\n        <input class="hide js-change-image-input" type="file" accept="image/*">\n    </div>\n    ';
 if (fullName || email) { 
__p+='\n    <div class="inline-block-element m-r-xl" style="vertical-align: top;">\n        <form class="form-inline">\n            <p class="employee-full-name">'+
((__t=( fullName ))==null?'':_.escape(__t))+
'</p>\n            <p class="employee-email">'+
((__t=( email ))==null?'':_.escape(__t))+
'</p>\n        </form>\n        ';
 if (sendButton) { 
__p+='\n        <button class="btn btn-outline btn-teal js-send-welcome-email">\n            Send welcome email\n        </button>\n        ';
 } 
__p+='\n    </div>\n\n    <div class="inline-block-element progress-container">\n        <div>\n            <span>Mandatory Fields Complete: '+
((__t=( profileProgress ))==null?'':_.escape(__t))+
'%</span>\n        </div>\n        <div class="progress">\n            <div class="progress-bar" role="progressbar"\n                 style="width:'+
((__t=( profileProgress ))==null?'':_.escape(__t))+
'%; background-color: '+
((__t=( profileProgress < 100 ? '#F7AF61' : '#41C43A' ))==null?'':_.escape(__t))+
';">\n            </div>\n        </div>\n    </div>\n    ';
 } 
__p+='\n\n    ';
 if (fullName || email) { 
__p+='\n    <div class="employee-nav">\n        <span class="employee-nav-box">\n            ';
 if (prev) { 
__p+='\n            <a href="#employee/'+
((__t=( prev ))==null?'':_.escape(__t))+
'/'+
((__t=( tab ))==null?'':_.escape(__t))+
'" class="js-change-employee">\n                <i class="fa fa-angle-left" aria-hidden="true"></i>\n                Previous\n            </a>\n            ';
 } else { 
__p+='\n            <a disabled class="disabled">\n                <i class="fa fa-angle-left" aria-hidden="true"></i>\n                Previous\n            </a>\n            ';
 } 
__p+='\n        </span>\n\n        <span class="employee-nav-box">\n            ';
 if (next) { 
__p+='\n            <a href="#employee/'+
((__t=( next ))==null?'':_.escape(__t))+
'/'+
((__t=( tab ))==null?'':_.escape(__t))+
'" class="js-change-employee">Next\n                <i class="fa fa-angle-right" aria-hidden="true"></i>\n            </a>\n            ';
 } else { 
__p+='\n            <a disabled class="disabled">Next\n                <i class="fa fa-angle-right" aria-hidden="true"></i>\n            </a>\n            ';
 } 
__p+='\n        </span>\n    </div>\n    ';
 } 
__p+='\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/employee/LayoutHeader.ejs
// module id = 777
// module chunks = 1